import { Link } from "react-router-dom";
import { categories } from "@/mocks/animeData";
import { countByCategory } from "@/utils/anime";

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
      {categories.map((item) => (
        <Link
          key={item.slug}
          to={`/category?category=${encodeURIComponent(item.slug)}`}
          className="group rounded-lg border border-background-300/50 bg-background-100/70 p-4 hover:border-accent-600/50 hover:bg-background-200/60 transition-colors cursor-pointer"
        >
          <span className="w-10 h-10 rounded-md bg-secondary-900/70 border border-background-300/50 flex items-center justify-center text-accent-400 group-hover:bg-primary-700 group-hover:text-foreground-950 transition-colors">
            <i className={`${item.icon} text-lg`} />
          </span>
          <h3 className="mt-3 text-sm text-foreground-900 group-hover:text-accent-400 transition-colors">{item.name}</h3>
          <p className="mt-1 text-[11px] text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
          <p className="mt-3 text-[11px] font-label tracking-widest text-accent-600/90">
            {countByCategory(item.slug)} 部作品
          </p>
        </Link>
      ))}
    </div>
  );
}